import classNames from 'classnames';
import * as React from 'react';
import { ArticleContributor } from '../../types/ArticleContributor';
import BusinessButton from '../business-button/business-button';
import { IconType } from '../icons';
import styles from './business-article-contributor-block.module.scss';
import IconAuthorAvatar from '../business-article-bio-block/IconAuthorAvatar';

interface Props {
    contributors: ArticleContributor[] | undefined;
    hasAuthorBefore?: boolean;
}
const ArticleContributorBlock = (props: Props) => {
    const { contributors, hasAuthorBefore } = props;
    const renderAuthorAvatar = (contributor: ArticleContributor) => {
        if (!contributor?.leadImage || contributor?.leadImage === '') {
            return <IconAuthorAvatar />;
        }
        return <div className={styles.businessArticleLeadImage} style={{ backgroundImage: `url('${contributor?.leadImage}')` }} />;
    };
    return (
        <div className={classNames(styles.businessArticleContributorListContainer, { [styles.hasAuthorBefore]: hasAuthorBefore })}>
            {contributors?.map((contributor) => (
                <div key={contributor.name} className={styles.businessArticleContributorContainer}>
                    <div className={styles.businessArticleContributorAvatar}>{renderAuthorAvatar(contributor)}</div>
                    <div className={styles.businessArticleInfo}>
                        <span className={styles.writtenBy}>Contributed by</span>
                        <div className={styles.name}>{contributor?.name}</div>
                        <div className={styles.bio}>{contributor?.bio}</div>
                        {contributor.ctaText && contributor.ctaUrl ? (
                            <div className={styles.cta}>
                                <BusinessButton size="small" icon={IconType.ArrowRightSmall} buttonText={contributor.ctaText} link={contributor.ctaUrl} />
                            </div>
                        ) : null}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ArticleContributorBlock;
